export default __webpack_public_path__ + "static/media/IconChevronLeft.c21db314.svg";